import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {OptionItem} from "FormBuilder/Fields/Options/OptionItem";
import {StoreDataType} from "shared/core/Store/StoreBase";
import {FBMultipleOptionsBaseOptions} from "FormBuilder/Fields/Core/FBMultipleOptionsBase.Options";


export class ButtonOptionItem extends OptionItem{
    public ImageType:'none'|'icon'|'image';
    public Ref:any;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.ImageType="none";
        this.Ref='';
    }
}


export class FBButtonSelectionOptions extends FBMultipleOptionsBaseOptions{

    public ShowQuantitySelector:boolean;
    @StoreDataType(ButtonOptionItem)
    public Options:ButtonOptionItem[];
    public ImagePosition:'top'|'bottom'|'left'|'right';
    public AllowMultipleSelection:boolean;
    public NumberOfColumns:number;
    public ShowPriceInEachButton:boolean;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=FieldTypeEnum.ButtonSelection;
        this.Label='Button Selection';
        this.Options=[];

        this.NumberOfColumns=3;
        this.ImagePosition='left';
        this.AllowMultipleSelection=false;

        this.ShowQuantitySelector=false;
        this.QuantityPosition='bottom';
        this.QuantityMaximumValue=0;
        this.QuantityMinimumValue=0;
        this.QuantityDefaultValue='';
        this.QuantityPlaceholder='';
        this.QuantityLabel='Quantity';
        this.ShowPriceInEachButton=true;

        this.PriceType=PriceTypeEnum.options;

        this.Options=[
            new ButtonOptionItem().Merge({Id:1, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 1',ImageType:'none',Ref:''}),
            new ButtonOptionItem().Merge({Id:2, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 2',ImageType:'none',Ref:''} ),
            new ButtonOptionItem().Merge({Id:3, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 3',ImageType:'none',Ref:''})
        ]


    }
}
